import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';

import {
  shouldShowNativeAppBanner,
  shouldShowPartnerRedirectionBanner,
} from 'common/util/isUserAgentMobileApp';
import branch from 'client/core/branch';

import SrLogo from 'client/components/SrLogo';
import SrNativeAppBanner from 'client/components/SrNativeAppBanner';
import SrLink from 'client/components/SrLink/SrLink';
import SrPartnerRedirectionBanner from 'client/components/SrPartnerRedirectionBanner/SrPartnerRedirectionBanner';

@withRouter
@branch({
  currentUser: ['currentUser'],
  userAgent: ['analytics', 'userAgent'],
})
class SrNavbar extends Component {
  static propTypes = {
    leftButton: PropTypes.node,
    rightButton: PropTypes.node,
    backButtonLink: PropTypes.string,
    secondaryRightButton: PropTypes.node,
    redirectLogoTo: PropTypes.string,
    disableRedirect: PropTypes.bool,
    hideNativeAppBanner: PropTypes.bool,
    userAgent: PropTypes.object.isRequired,
    currentUser: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
  };

  static defaultProps = {
    redirectLogoTo: '/feed',
  };

  render() {
    const {
      leftButton,
      rightButton,
      backButtonLink,
      secondaryRightButton,
      redirectLogoTo,
      disableRedirect,
      hideNativeAppBanner,
      userAgent,
      currentUser,
      location,
    } = this.props;

    const showNativeAppBanner =
      !hideNativeAppBanner &&
      shouldShowNativeAppBanner({
        userAgent,
        currentUser,
        location,
      });

    const showPartnerRedirectionBanner = shouldShowPartnerRedirectionBanner({
      location,
      currentUser,
    });

    return (
      <div className="SrNavbar">
        <div className="SrNavbarWrapper">
          {showNativeAppBanner && <SrNativeAppBanner />}
          {showPartnerRedirectionBanner && <SrPartnerRedirectionBanner />}
          <div className="SrNavbarContainer">
            <span className="link left">
              {backButtonLink && (
                <SrLink to={backButtonLink}>
                  <span className="link back">Back</span>
                </SrLink>
              )}
              {leftButton}
            </span>
            <SrLogo redirectTo={redirectLogoTo} disableRedirect={disableRedirect} />
            {secondaryRightButton && (
              <span className="link secondaryRight">{secondaryRightButton}</span>
            )}
            <span className="link right">{rightButton}</span>
          </div>
        </div>
      </div>
    );
  }
}

SrNavbar.displayName = 'SrNavbar';

export default SrNavbar;
